import { useState } from 'react';

export const useModals = () => {
  const [isAddBankModalOpen, setIsAddBankModalOpen] = useState(false);

  const handleAddBankAccount = () => {
    try {
      setIsAddBankModalOpen(true);
    } catch (error) {
      console.error('Error opening add bank modal:', error);
    }
  };

  return {
    isAddBankModalOpen,
    setIsAddBankModalOpen,
    handleAddBankAccount,
  };
};

